
import React from 'react';

const NotificationIcon = ({
  onClick,
  className = '',
  size = 'desktop',
  unreadCount = 0,
}) => {
  const isMobile = size === 'mobile';
  const buttonSize = isMobile ? '35px' : '43px';
  const padding = isMobile ? '15px' : '20px';
  const svgSize = isMobile ? '12px' : '14px';
  const svgHeight = isMobile ? '16px' : '20px';

  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center cursor-pointer transition-all duration-200 hover:scale-105 ${className}`}
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding,
        gap: '8px',
        width: buttonSize,
        height: buttonSize,
        background:
          'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0) 100%), rgba(40, 227, 218, 0.25)',
        boxShadow: '0px 8px 32px rgba(255, 255, 255, 0.08)',
        backdropFilter: 'blur(1px)',
        borderRadius: '100px',
        flex: 'none',
        order: 0,
        flexGrow: 0,
      }}
    >
      <div
        style={{
          position: 'relative',
          width: svgSize,
          height: svgHeight,
          flex: 'none',
          order: 0,
          flexGrow: 0,
        }}
      >
        <svg
          width={svgSize}
          height={svgHeight}
          viewBox="0 0 23 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            width: svgSize,
            height: svgHeight,
          }}
        >
          <path
            d="M13.0078 22.8486C12.9291 22.999 12.8278 23.1392 12.7031 23.2617C12.3863 23.573 11.9536 23.75 11.5 23.75C11.0464 23.75 10.6137 23.573 10.2969 23.2617C10.1722 23.1392 10.0709 22.999 9.99219 22.8486H13.0078ZM11.5059 1.25C11.753 1.25 11.9972 1.30299 12.2207 1.4043C12.444 1.50559 12.6417 1.65284 12.7998 1.83496C12.9578 2.01703 13.0733 2.22966 13.1387 2.45801C13.204 2.68646 13.2177 2.9261 13.1797 3.16016L13.0781 3.78418L13.6768 3.98926C14.9686 4.43302 16.0853 5.26048 16.874 6.35352C17.6627 7.44644 18.0844 8.75208 18.083 10.0889V17.7002L18.4229 17.9219L21.75 20.1016V20.1475H1.25V20.1016L4.57715 17.9219L4.91699 17.7002V10.0889C4.91643 8.75094 5.33931 7.44456 6.12988 6.35156C6.92075 5.25828 8.04097 4.43218 9.33496 3.99023L9.93457 3.78516L9.83203 3.16016C9.79401 2.9261 9.80867 2.68646 9.87402 2.45801C9.93939 2.01705 10.0548 1.83496 10.2129 1.83496C10.3711 1.65277 10.5685 1.50559 10.792 1.4043C11.0154 1.30306 11.2589 1.25004 11.5059 1.25Z"
            stroke="#D5D2D2"
            strokeWidth="1.5"
          />
        </svg>

        {unreadCount > 0 && (
          <div
            style={{
              position: 'absolute',
              width: isMobile ? '6px' : '6.5px',
              height: isMobile ? '6px' : '6.5px',
              right: '-2px',
              top: '-2px',
              background: '#F18921',
              borderRadius: '50%',
            }}
          />
        )}
      </div>
    </button>
  );
};

export default NotificationIcon;
